import React, { useRef, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import StickerComponentPrint from "./stickerComponentPrint";
import PrintLayout from "./stickerComponentPrint/PrintLayout";
import { useReactToPrint } from 'react-to-print';
import printIcon from '../images/printer_icon.svg';
import axios from 'axios';
import HE from '../languages/he';


const CoffeeSticker = () => {
  const { lang, coffeeID } = useParams();
  const componentRef = useRef();
  const printRef = useRef();
  const [productLink, setProductLink] = useState('');
  const languageFile = HE;

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: `
      @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap');
      @page { size: A6 landscape; margin: 0; }
      * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; color-adjust: exact !important; }
      html, body { margin: 0 !important; padding: 0 !important; background: #121010 !important; overflow: hidden !important; }
      /* sp-print-page is sized in physical mm — DPI-independent, works on every printer */
      body .sp-print-page { width: 148mm !important; height: 105mm !important; overflow: hidden !important; position: relative !important; }
      /* zoom scales both layout and rendering — Safari/Chrome/Edge/Firefox 126+ print-safe */
      body .sp-wrapper { position: absolute !important; top: 0 !important; left: 0 !important; zoom: 0.494 !important; }
    `,
  });

  useEffect(() => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      // url: 'https://agro-caffe.vercel.app/api/get-blend-data/'+coffeeID,
      url: 'https://mycoffeeid.com/api/get-blend-data/'+coffeeID,
      data: ''
    };
    axios.request(config)
      .then((response) => {
        let result = response.data;
        if (result.blendName) {
          let link = 'https://agrocafe.co.il/custom_editor.php?product_id=27753';
          link += '&quantity=1';

          // blend types
          let blendTypes = result.blendTypes;
          Object.keys(blendTypes).forEach((key) => {
            let urlKey = key === 'colombia' ? 'columbia' : key;
            link += '&' + urlKey + '=' + blendTypes[key];
          });

          // roasting level
          let roastingLevels = languageFile.product.roastingLevels;
          link += '&roasting_level=' + roastingLevels[result.roastingLevel - 1];

          // coffee type
          let coffeeType = languageFile.firstStep.coffeeTypes[result.clientDetails.type];
          link += '&client_coffee_type=' + coffeeType;

          // client preferences
          let prefs = result.clientDetails.preferences;
          link += '&client_preferences[acidity]=' + prefs.acidity;
          link += '&client_preferences[sweetness]=' + prefs.sweetness;
          link += '&client_preferences[bitterness]=' + prefs.bitterness;
          link += '&client_preferences[body]=' + prefs.body;

          // client taste notes
          let tasteNotesArr = [];
          result.clientDetails.tasteNotes.forEach((el) => {
            tasteNotesArr.push(languageFile.thirdStep.notes[el].title);
          });
          link += '&client_taste_notes=' + tasteNotesArr.join(',');

          // matching percentage
          link += '&matching_percentage=' + result.match;

          // blend preferences
          let bp = result.blendPreferences;
          link += '&blend_preferences[acidity]=' + bp.acidity;
          link += '&blend_preferences[sweetness]=' + bp.sweetness;
          link += '&blend_preferences[bitterness]=' + bp.bitterness;
          link += '&blend_preferences[body]=' + bp.body;

          // blend taste notes
          let blendNotes = result.blendTasteNotes;
          if (blendNotes) {
            let tasteNoteKeys = languageFile.coffeeSticker.tasteNoteKeys;
            Object.keys(blendNotes).forEach((noteKey) => {
              let localizedKey = tasteNoteKeys[noteKey] || noteKey;
              link += '&blend_taste_notes[' + localizedKey + ']=' + blendNotes[noteKey].join(',');
            });
          }

          link += '&sticker_id=' + coffeeID;
          setProductLink(link);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [coffeeID]);

  return(
    <>
      <div className="sticker-page">
        <button onClick={handlePrint} className="print-btn">
          {languageFile.coffeeSticker.printBtn}
          <img src={printIcon} alt=""/>
        </button>
        {productLink && (
          <a href={productLink} target="_blank" rel="noreferrer" className="reorder-btn">
            {languageFile.coffeeSticker.reorderBtn}
          </a>
        )}
        <StickerComponentPrint coffeeID={coffeeID} lang={lang} ref={componentRef}/>

        {/* Hidden print target — off-screen, react-to-print captures it */}
        <div style={{ position: 'fixed', left: '-9999px', top: 0, pointerEvents: 'none' }}>
          <PrintLayout coffeeID={coffeeID} lang={lang} ref={printRef}/>
        </div>

        {productLink && (
          <div className="sticker-footer">
            <a href={productLink} target="_blank" rel="noreferrer" className="reorder-btn">
              {languageFile.coffeeSticker.reorderAgainBtn}
            </a>
          </div>
        )}
      </div>
    </>
  )
}

export default CoffeeSticker;